<template>
  <div class="skeleton-cart">
    <div v-for="n in rows" :key="n" class="skeleton-item">
      <div class="skeleton-thumb shimmer"></div>
      <div class="skeleton-content">
        <div class="skeleton-line title shimmer"></div>
        <div class="skeleton-line price shimmer"></div>
      </div>
      <div class="skeleton-controls">
        <div class="skeleton-btn shimmer"></div>
        <div class="skeleton-btn shimmer"></div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "CartSkeleton",
  props: {
    rows: { type: Number, default: 5 }
  }
};
</script>

<style scoped>
.skeleton-cart {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}

.skeleton-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.skeleton-thumb {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  margin-right: 12px;
  background: #f0f0f0;
}

.skeleton-content {
  flex: 1;
}

.skeleton-line {
  height: 12px;
  border-radius: 6px;
  margin-bottom: 8px;
  background: #f0f0f0;
}

.skeleton-line.title {
  width: 60%;
  height: 14px;
}

.skeleton-line.price {
  width: 40%;
}

.skeleton-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.shimmer {
  background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s linear infinite;
}

@keyframes shimmer {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}
</style>
